import { render, staticRenderFns } from "./DialogCreateIsapreType.vue?vue&type=template&id=21e75c47&lang=pug&"
import script from "./DialogCreateIsapreType.vue?vue&type=script&lang=js&"
export * from "./DialogCreateIsapreType.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateIsapreType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogCreateIsapreType.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
